// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"cdd1f1eb","793":"8e4818ef","890":"c15abcfb"}[chunkId] + ".chunk.js";
};